var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgArrowLeft = function SvgArrowLeft(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 207 207",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.627 205.107C204.593 202.927 205.24 198.754 203.059 195.786L136.556 105.1L175.458 52.0499L164.704 44.1572L120.014 105.1L192.299 203.673C194.48 206.64 198.653 207.286 201.627 205.107ZM183.345 41.2956L191.226 30.5414L180.478 22.6486L172.584 33.4029L183.345 41.2956ZM199.112 19.7887L207 9.03444L196.246 1.15308L188.359 11.9074L199.112 19.7887Z",
    fill: "#FF7043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.549 205.106C170.515 202.927 171.163 198.753 168.982 195.786L102.478 105.1L168.975 14.4138C171.156 11.4481 170.509 7.27303 167.543 5.09353C164.569 2.91403 160.396 3.55372 158.214 6.52754L85.9295 105.1L158.221 203.672C160.402 206.64 164.576 207.286 167.549 205.106V205.106Z",
    fill: "#FDD835"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 207,
    height: 207,
    fill: "white",
    transform: "matrix(-1 0 0 1 207 0)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-left.3b396eba.svg";
export { ForwardRef as ReactComponent };